import { useState } from "react";
import { Dropdown } from "./Dropdown";
import { Submenu } from "./Submenu";
import { NavLink } from "react-router-dom";
import { logout } from "../utils";
import { Autorization } from "./Autorization";

export const Navbar = () => {

    const logoutSystem = () => {
        logout();
        window.location.reload();
    };

    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    //PARA USUARIOS ADMINISTRADORES
    const itemsInformacion = [
        { id: 1, label: "Usuarios", href: "/usuario" },
        { id: 2, label: "Colaboradores", href: "/colaborador" },
        { id: 3, label: "Puestos", href: "/puesto" },
        { id: 4, label: "Agencias", href: "/agencia" },
    ];
    const titleInformacion = "MANEJO DE INFORMACIÓN";

    //PARA USO DE LOS VALUADORES
    const itemsAvaluo = [
        { id: 1, label: "Generar Avalúo", href: "/avaluo" },
        { id: 2, label: "Estado del Avalúo", href: "/estadoavaluo" },
    ];
    const titleAvaluo = "GESTIÓN DE AVALÚOS";

    //PARA USO DE LA SECRETARIA
    const itemsManejoAvaluo = [
        { id: 1, label: "Pendientes de aprobación", href: "/pendienteaprobacion" },
        { id: 2, label: "Pendientes de autorización", href: "/pendienteautorizados" },
        { id: 3, label: "Autorizados", href: "/autorizados" },
    ];
    const titleManejoAvaluo = "MANEJO DE AVALÚOS";

    //PARA USO DEL JEFE DE AVALUOS
    const itemsManejoAvaluoJefe = [
        { id: 1, label: "Pendientes de aprobación", href: "/pendienteaprobacion" },
        { id: 2, label: "Pendientes de autorización", href: "/pendienteautorizacion" },
        { id: 3, label: "Autorizados", href: "/autorizados" },
    ];
    const titleManejoAvaluoJefe = "MANEJO DE AVALÚOS";

    //PARA USO DE ADMINISTRADORES
    const itemsManejoAvaluoAdmon = [
        { id: 1, label: "Retroceder fase", href: "/retrocederfase" },
        { id: 2, label: "Autorizados", href: "/autorizados" },
    ];
    const titleManejoAvaluoAdmon = "MANEJO DE AVALÚOS";

    //PARA CONSULTA
    const itemsManejoAvaluoConsulta = [
        { id: 1, label: "Autorizados", href: "/consultas" },
    ];
    const titleManejoAvaluoConsulta = "CONSULTA DE AVALÚOS";

    //PARA LOS ASESORES DE CREDITOS
    const itemsManejoAvaluoAsesor = [
        { id: 1, label: "Solicitar", href: "/solicitud" },
    ];
    const titleManejoAvaluoAsesor = "SOLICITUD DE AVALÚOS";

    //PARA LA SECRETARIA DE AVALUOS
    const itemsManejoAvaluoSolicitud = [
        { id: 1, label: "Solicitudes", href: "/solicitud" },
    ];
    const titleManejoAvaluoSolicitud = "SOLICITUD DE AVALÚOS";

    //PARA LA SECRETARIA DE AVALUOS, JEFE DE AVALUOS Y GERENTES
    const itemsReportes = [
        { id: 1, label: "Reportes", href: "/reportes" },
        { id: 2, label: "Referenciales", href: "/referenciales" },
    ];
    const titleReportes = "REPORTERÍA";


    return (
        <nav
            className="w-full z-30 top-10 bg-white shadow-lg shadow-slate-100 mt-0"
        >
            <div className="w-full flex items-center justify-between mt-0 px-6 py-2 ">
                <div className="site-logo">
                    <a href="/">
                        <img
                            className="w-28 cursor-pointer md:w-52"
                            src="data:image/png;base64,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"
                            alt="#"
                        />
                    </a>
                </div>

                {/* menu normal */}
                <div
                    className=" md:flex w-full hidden justify-between"
                >
                    <nav>
                        <ul className="md:flex items-center justify-between text-xs text-gray-500 pt-4 md:pt-0">
                            <li>
                                <NavLink
                                    to='/'
                                    className="rounded transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-transparent cursor-pointer inline-block no-underline hover:bg-blue-50 font-bold text-xs py-2 px-4 lg:ml-2 mr-2"
                                >
                                    INICIO
                                </NavLink>

                                {/* <Autorization rols={[1]}>
                                    <NavLink
                                        to='/usuario'
                                        className="rounded transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-transparent cursor-pointer inline-block no-underline hover:bg-blue-50 font-bold text-xs py-2 px-4 lg:ml-2 mr-2"
                                    >
                                        USUARIOS
                                    </NavLink>
                                </Autorization> */}

                                <Autorization rols={[1]}>
                                    <Dropdown items={itemsInformacion} title={titleInformacion} />
                                </Autorization>

                                <Autorization rols={[2, 3, 4]}>
                                    <Dropdown items={itemsManejoAvaluoSolicitud} title={titleManejoAvaluoSolicitud} />
                                </Autorization>

                                <Autorization rols={[3]}>
                                    <Dropdown items={itemsAvaluo} title={titleAvaluo} />
                                </Autorization>

                                <Autorization rols={[4, 7]}>
                                    <Dropdown items={itemsManejoAvaluo} title={titleManejoAvaluo} />
                                </Autorization>

                                <Autorization rols={[2]}>
                                    <Dropdown items={itemsManejoAvaluoJefe} title={titleManejoAvaluoJefe} />
                                </Autorization>

                                <Autorization rols={[1]}>
                                    <Dropdown items={itemsManejoAvaluoAdmon} title={titleManejoAvaluoAdmon} />
                                </Autorization>

                                <Autorization rols={[6]}>
                                    <Dropdown items={itemsManejoAvaluoAsesor} title={titleManejoAvaluoAsesor} />
                                </Autorization>

                                <Autorization rols={[5, 6, 8]}>
                                    <Dropdown items={itemsManejoAvaluoConsulta} title={titleManejoAvaluoConsulta} />
                                </Autorization>

                                <Autorization rols={[1, 2, 4, 7, 8]}>
                                    <Dropdown items={itemsReportes} title={titleReportes} />
                                </Autorization>

                            </li>
                        </ul>
                    </nav>

                    <div
                        className="order-2 md:order-3 flex flex-wrap items-center justify-end mr-0 md:mr-4"
                    >
                        <div className="auth flex items-center w-full md:w-full">
                            <button
                                onClick={logoutSystem}
                                className="text-xs transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300 bg-transparent text-gray-500 hover:text-white font-bold  p-2 rounded mr-4 hover:bg-red-500 "
                            >
                                CERRAR SESIÓN
                            </button>
                        </div>
                    </div>
                </div>

                {/* hamburgesa */}
                <div className="md:hidden">
                    <label
                        htmlFor="menu-toggle"
                        className="cursor-pointer md:hidden block ml-auto"
                    >
                        <button onClick={toggleMenu}>
                            {isOpen ?
                                < svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 fill-current text-blue-900">
                                    <title>cerrar</title>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                :
                                <svg
                                    className="fill-current text-blue-900 "
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                >
                                    <title>menu</title>
                                    <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"></path>
                                </svg>

                            }

                        </button>
                    </label>

                    <div
                        className={`${isOpen ? "animate__animated animate__backInDown animate__faster" : "animate__animated animate__backOutUp"
                            } absolute inset-x-0 bg-white z-50 mt-2 mx-3 rounded-lg shadow-2xl`}
                        id="menu"
                    >
                        <ul className="w-full items-center justify-end text-xs text-gray-500">
                            <li className="">
                                {/* <Autorization rols={[1]}>
                                    <Submenu title='MANEJO DE USUARIOS' titleLink='/usuario' />
                                </Autorization> */}

                                <Autorization rols={[1]}>
                                    <Submenu items={itemsInformacion} title={titleInformacion} />
                                </Autorization>

                                <Autorization rols={[2, 3, 4]}>
                                    <Submenu items={itemsManejoAvaluoSolicitud} title={titleManejoAvaluoSolicitud} />
                                </Autorization>

                                <Autorization rols={[3]}>
                                    <Submenu items={itemsAvaluo} title={titleAvaluo} />
                                </Autorization>

                                <Autorization rols={[4, 7]}>
                                    <Submenu items={itemsManejoAvaluo} title={titleManejoAvaluo} />
                                </Autorization>

                                <Autorization rols={[2]}>
                                    <Submenu items={itemsManejoAvaluoJefe} title={titleManejoAvaluoJefe} />
                                </Autorization>

                                <Autorization rols={[1]}>
                                    <Submenu items={itemsManejoAvaluoAdmon} title={titleManejoAvaluoAdmon} />
                                </Autorization>

                                <Autorization rols={[6]}>
                                    <Submenu items={itemsManejoAvaluoAsesor} title={titleManejoAvaluoAsesor} />
                                </Autorization>

                                <Autorization rols={[5, 6, 8]}>
                                    <Submenu items={itemsManejoAvaluoConsulta} title={titleManejoAvaluoConsulta} />
                                </Autorization>

                                <Autorization rols={[1, 2, 4, 7, 8]}>
                                    <Submenu items={itemsReportes} title={titleReportes} />
                                </Autorization>

                                <div className="auth ml-4 flex justify-start w-full md:w-full">
                                    <button
                                        onClick={logoutSystem}
                                        className="text-xs transition ease-in-out delay-150 hover:-translate-y-0.5  duration-300 bg-transparent text-gray-500 hover:text-white font-bold  p-2 rounded mr-4 hover:bg-red-500 "
                                    >
                                        CERRAR SESIÓN
                                    </button>
                                </div>

                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav >
    );
};
